














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
// ({                  // sometimes doesn't work
//     props: {
//         label: '',
//         value: ''
//     }
// })
export default class StoreDebugValue extends Vue {
    @Prop() label!: string;
    @Prop() value!: string;
}
